export class Pump {
    pumpId: number;
    runningHours?: number;

    constructor(pumpId: number, runningHours?: number) {
        this.pumpId = pumpId;
        this.runningHours = runningHours;
    }
}
